<template>
    <div :key="localKey">
        <app-new-breadcrumb></app-new-breadcrumb>
        <div class="main-part">
            <div class="accordion custom-accordion" role="tablist">
                <b-card v-for="(yearContent, index) in lastThreeYearsContent" :key="yearContent.id" no-body
                    class="mb-3 custom-card">
                    <b-card-header header-tag="header" class="p-0" role="tab">
                        <b-button block :id="`accordion-${index}-btn`" v-b-toggle="`accordion-${index}`" variant="info"
                            class="custom-button text-left">
                            {{ yearContent.title }}
                        </b-button>
                    </b-card-header>
                    <b-collapse :id="`accordion-${index}`" :visible="index === 0" accordion="my-accordion"
                        role="tabpanel">
                        <b-card-body class="custom-card-body">
                            <b-table-simple v-if="getChildrenContent(yearContent.id).length > 0" hover responsive
                                class="custom-table">
                                <tbody>
                                    <tr v-for="child in getChildrenContent(yearContent.id)" :key="child.id">
                                        <td class="text-left">{{ child.title }}</td>
                                        <td class="text-center"><a v-bind:href="child.url" target="_blank">{{
                                            $t("openPublication") }}</a></td>
                                    </tr>
                                </tbody>
                            </b-table-simple>
                            <p v-else class="text-left py-3 no-content">{{ $t("noResults") }}</p>
                        </b-card-body>
                    </b-collapse>
                </b-card>
                <p v-if="lastThreeYearsContent.length === 0" class="text-left py-3 no-content">{{ $t("noResults") }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from "../../common/Breadcrumb.vue";

export default {
    data() {
        return {
            localKey: 0,
            slugByLang: {
                en: 'publications',
                bs: 'publikacije',
                hr: 'publikacije',
            },
        }
    },
    components: {
        appNewBreadcrumb: Breadcrumb,
    },
    computed: {
        ...mapGetters(["getChildrenByParentId", "getContentById", "getContentByUrl", "getSelectedLanguage"]),
        currentContentId() {
            let parent = this.getContentByUrl(this.$route.name);
            return parent ? parent.id : null;
        },

        lastThreeYearsContent() {
            if (!this.currentContentId) return [];
            const children = this.getChildrenByParentId(this.currentContentId);
            const sortedChildren = [...children].sort((a, b) =>
                (b.ordinalNumber || 0) - (a.ordinalNumber || 0)
            );
            return sortedChildren.slice(0, 3);
        },

    },
    methods: {
        getChildrenContent(parentId) {
            return this.getChildrenByParentId(parentId);
        },
        normLang(langRaw, route = this.$route) {
            if (route && route.params && typeof route.params.lang === 'string' && route.params.lang.length >= 2) {
                return route.params.lang.slice(0, 2).toLowerCase();
            }

            if (typeof langRaw === 'string') {
                const s = langRaw.split(/[-_]/)[0];
                return s.slice(0, 2).toLowerCase();
            }

            if (langRaw && typeof langRaw === 'object') {
                const candidate =
                    langRaw.code ||
                    langRaw.key ||
                    langRaw.locale ||
                    langRaw.lang ||
                    langRaw.language ||
                    ''; 
                if (typeof candidate === 'string') {
                    const s = candidate.split(/[-_]/)[0];
                    return s.slice(0, 2).toLowerCase();
                }
            }
            return 'en';
        },

        ensureCorrectSlug(langRaw, toRoute = null) {
            const route = toRoute || this.$route;
            const lang = this.normLang(langRaw, route); 
            const slugByLang = { en: 'publications', bs: 'publikacije', hr: 'publikacije' };
            const desiredSlug = slugByLang[lang];

            if (!desiredSlug) {
                return;
            }

            const path = route.path;                       
            const parts = path.split('/').filter(Boolean); 

            if (parts.length < 2) return;

            const currentLang = parts[0];
            const currentSlug = parts[1];

            let changed = false;

            if (currentLang !== lang) {
                parts[0] = lang;
                changed = true;
            }

            if (currentSlug !== desiredSlug) {
                parts[1] = desiredSlug;
                changed = true;
            }

            if (!changed) return; 

            const newPath = '/' + parts.join('/');

            this.$router.replace({
                path: newPath,
                query: route.query,
                hash: route.hash,
            }).catch(() => { });

            this.localKey++; 
        },
    },
    created() {
        this.ensureCorrectSlug(this.getSelectedLanguage);
    },
    mounted() {
    },
    beforeRouteUpdate(to, from, next) {
        this.ensureCorrectSlug(this.getSelectedLanguage, to);
        next();
    },
    watch: {
        getSelectedLanguage: {
            immediate: false,
            handler(lang) {
                this.ensureCorrectSlug(lang);
            }
        },
        '$route.fullPath'(to, from) {
            this.ensureCorrectSlug(this.getSelectedLanguage);
        },
    }
}
</script>

<style scoped>
.main-part {
    padding: 0% 7%;
    margin-bottom: 2%;
}

.content-menu-title {
    background-color: #FFF;
    padding: 2%;
    color: var(--main-color);
    box-shadow: 0px 2px 6px 1px rgba(0, 0, 0, 0.15);
    border-top: 1px solid rgba(0, 0, 0, 0.06);
}

.custom-accordion {
    max-width: 100%;
    margin: 0;
    padding: 0;
}

.custom-card {
    border: none;
    margin-bottom: 1px !important;
    box-shadow: none;
}

.custom-button {
    background-color: var(--main-color) !important;
    border: none !important;
    color: white !important;
    /* font-size: 1rem !important; */
    font-size: 18px;
    font-weight: normal !important;
    letter-spacing: normal;
    padding: 0.75rem 1rem;
    text-transform: none;
    border-radius: 0 !important;
}

.card-header {
    padding: 0;
    border-radius: 0 !important;
    border: none;
}

.collapse,
.collapsing {
    border-radius: 0 !important;
}

.card {
    border-radius: 0 !important;
}

.custom-button:hover,
.custom-button:focus {
    background-color: var(--main-color-active) !important;
    box-shadow: none !important;
}

.custom-card-body {
    background-color: white;
    padding: 0;
    border: none;
}

.custom-table {
    width: 100%;
    background-color: white;
    margin: 0;
}

.custom-table th,
.custom-table td {
    padding: 0.75rem;
    border: 1px solid #dee2e6;
    vertical-align: middle;
    font-size: 0.9rem;
}

.custom-table th {
    font-weight: 600;
    background-color: var(--secondary-color);
    color: var(--main-color);
    border: 1px solid #dee2e6;
}

.table {
    border-radius: 0 !important;
}

.table-hover tbody tr:hover {
    background-color: #f8f9fa !important;
}

.no-content {
    color: #666;
    margin: 0;
    padding: 1rem;
}

.mb-3 {
    margin-bottom: 0 !important;
}

.custom-card+.custom-card {
    border-top: none;
}

.text-center a {
    color: var(--main-color-active);
}
</style>
